import { LINKS } from "@silo/types";
import { MoneyIcon } from "../../icons";
import { cn } from "../../utils/class-names";
import { ExternalLink } from "../link";

interface RevenueDetailsProps {
  className?: string;
  symbol: string;
}

export function RevenueDetails({
  className,
  symbol,
}: RevenueDetailsProps): JSX.Element {
  return (
    <div className="flex flex-col gap-5">
      <div
        className={cn(
          "rounded-lg bg-green-400/10 p-2.5 text-green-400 flex items-center gap-2.5",
          className
        )}
      >
        <div>
          <MoneyIcon className="w-6 h-6" />
        </div>

        <div>SiloDAO is distributing revenues to {symbol} depositors</div>
      </div>

      <ExternalLink size="small" href={LINKS.REVENUE_DETAILS}>
        Revenue details
      </ExternalLink>
    </div>
  );
}
